import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var GitBranchPlus = createReactComponent("GitBranchPlus", ["svg", defaultAttributes, [["path", {
  d: "M6 3v12",
  key: "13fvxb"
}], ["path", {
  d: "M18 9a3 3 0 100-6 3 3 0 000 6z",
  key: "1bjcfs"
}], ["path", {
  d: "M6 21a3 3 0 100-6 3 3 0 000 6z",
  key: "1t59tx"
}], ["path", {
  d: "M15 6a9 9 0 00-9 9",
  key: "1yzcpc"
}], ["path", {
  d: "M18 15v6",
  key: "p8g77l"
}], ["path", {
  d: "M21 18h-6",
  key: "md2nyt"
}]]]);
export default GitBranchPlus;